import { createContext } from "react";
import {
    ActionPlanOverview,
    CompanyOverview,
    QuestionnaireOverview,
    ScoreOverview,
} from "src/api/client-api/company/overview/useOrganizationOverview";

export type CompanyOneSsqOverview = {
    ssq: QuestionnaireOverview;
    actionPlan: ActionPlanOverview | null;
    scores: ScoreOverview[];
};

export type CompanyOverviewInit = {
    companyId: number;
    ssqId: string | undefined;
    ssqVersionId: number | undefined;
    isRefetching: boolean;
    filteredOverview: CompanyOneSsqOverview | null;
    overview: CompanyOverview;
    selectVariation: (scoreId: number, variationId: number | null) => void;
    // overviewScoreId: number | null;
    // setOverviewScoreId: (scoreId: number | null) => void;
    // variations: ScoreWithVariation[];
};
export const CompanyOverviewContext = createContext<CompanyOverviewInit | null>(null);
